import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Label, Modal, ModalBody, Row, Spinner, Table } from "@/Components/ui";
;
import { API_TICKET_ALL, API_RESERVATION_ALL, API_SALES_ADJUSTMENTS, BACKEND_HOST, getDataFromUrl, API_SALES_ADJUSTMENTS_ENTITY, postData } from "../../../api";
import { siteBillingService } from "../../../api/services/site-billing.service";
import type { SiteBillingMeStatus } from "../../../api/types/site-billing";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Widgets from "../../../Components/Common/Widgets";
import StatisticDetail from "./StatisticDetail";
import Select from "react-select";
import SummaryTable from "./SummaryTable";
import { read, utils, writeFileXLSX, writeFile } from "xlsx";
import ReceiptModal from "./ReceiptModal";
import { dialogService } from "@/utils/dialogService";
import { formatMonth, formatWon, statusLabel } from "../../SiteBilling/siteBillingFormat";
function formatPrice(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function openWindowWithTable(datas, header = { title: "", description: "description" }) {
    var a = window.open("", "", "height=1024, width=768");
    a.document.write("<html>");
    a.document.write("<body>");
    if (header.title) {
        a.document.write(`<h1>${header.title}</h1>`);
        a.document.write(`<p>${header.description}</p>`);
    }
    a.document.write('<table class="custom-header-css table" style="border: 1px solid black; border-collapse: collapse; border-spacing: 0;">');
    a.document.write('<thead className="table-light text-muted"><tr>');
    for (const tableColumn in datas[0]) {
        if (Object.hasOwnProperty.call(datas[0], tableColumn)) {
            // const element = datas[0][tableColumn];
            a.document.write(`<th style="border: 1px solid black;">${tableColumn}</th>`);
        }
    }
    a.document.write("</tr></thead>");
    a.document.write('<tbody className="table-light text-muted">');
    for (let i = 0; i < datas.length; i++) {
        const data = datas[i];
        a.document.write("<tr>");
        for (const tableColumn in data) {
            if (Object.hasOwnProperty.call(data, tableColumn)) {
                const element = data[tableColumn];
                a.document.write(`<td style="border: 1px solid black;">${element}</td>`);
            }
        }
        a.document.write("</tr>");
    }
    a.document.write("</tbody>");
    a.document.write("</table></body></html>");
    a.document.close();
}
function export_reservation_data(data) {
    return data
        .sort((a, b) => (moment(a["예약시작일"]) > moment(b["예약시작일"]) ? 1 : -1))
        .map((item) => {
        const sum_total = item["결제금액"] +
            item["options"]
                .map((item) => {
                return item.price;
            })
                .reduce((sum, currValue) => {
                return sum + currValue;
            }, 0);
        return {
            // id	package_id	예약신청일	예약상품	자리	예약자	번호	예약시작일	이용기간	예약상태	결제상태	승인번호	결제금액	gifted	options
            예약일: item["예약시작일"],
            예약종료일: item["예약종료일"],
            예약상품: item["예약상품"],
            자리: item["자리"],
            예약자: item["예약자"],
            전화번호: item["번호"],
            예약상태: item["예약상태"],
            결재일: moment(item["예약신청일"]).format("YYYY-MM-DD"),
            결제상태: item["결제상태"],
            승인번호: !!item["승인번호"] ? item["승인번호"] : "",
            예약결제금액: item["결제금액"],
            선물상태: item["gifted"],
            옵션상품: item["options"]
                .map((item) => {
                return item.name;
            })
                .reduce((text, currValue) => {
                if (text)
                    return text + ", " + currValue;
                else
                    return currValue;
            }, ""),
            // "옵션상품": JSON.stringify(item["options"]),
            총액: sum_total,
        };
    });
}
function export_ticket_data(data) {
    return data
        .sort((a, b) => (moment(a["사용일"]) > moment(b["사용일"]) ? 1 : -1))
        .map((item) => {
        return {
            // "id": item["id"],
            고객명: item["이름"],
            전화번호: item["고객"],
            상품: item["상품"],
            상태: item["상태"],
            사용일: moment(item["사용일"]).format("YYYY-MM-DD"),
            // "만료일": item["만료일"],
            선물상태: item["gifted"],
            // "가격": item["가격"],
            가격: item["paid_amount"],
        };
    });
}
export function BillingOverviewCards({ billingStatus }: { billingStatus?: SiteBillingMeStatus }) {
    const infraUrl = billingStatus?.infra_billing_url || "https://www.amzinfra.site/site/billing";
    return (<div className="mb-4 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
                <BillingInfoCard title="Billing 정책" value={billingStatus?.enabled ? `${formatWon(billingStatus.current_fixed_monthly_amount)} / ${Number(billingStatus.current_sales_fee_rate_bps ?? 0) / 100}%` : "비노출"} caption={billingStatus?.billing_state ? statusLabel(billingStatus.billing_state) : "사용료 정책"} />
                <BillingInfoCard title="최근 청구서" value={billingStatus?.latest_invoice_number || "-"} caption={`${formatMonth(billingStatus?.latest_billing_month)} · ${formatWon(billingStatus?.latest_amount_due)}`} />
                <BillingInfoCard title="청구 상태" value={statusLabel(billingStatus?.latest_invoice_status)} caption={`미납 ${formatWon(billingStatus?.unpaid_balance)} · 연체 ${formatWon(billingStatus?.overdue_balance)}`} />
                <Card className="h-full min-h-[112px] min-w-0 overflow-visible">
                    <CardBody className="flex min-w-0 flex-col justify-between gap-2">
                        <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">Amazing Infra</p>
                        <h5 className="mb-0 break-words leading-snug">사용료 관리</h5>
                        <Button color="primary" size="sm" onClick={() => window.open(infraUrl, "_blank", "noopener,noreferrer")}>
                            바로가기
                        </Button>
                    </CardBody>
                </Card>
        </div>);
}
export function BillingInfoCard({ title, value, caption }: { title: string; value: string; caption: string }) {
    return (<Card className="h-full min-h-[112px] min-w-0 overflow-visible">
            <CardBody className="flex min-w-0 flex-col justify-between gap-2">
                <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">{title}</p>
                <h5 className="mb-0 break-words leading-snug">{value}</h5>
                <span className="block break-words text-muted fs-12 leading-snug">{caption}</span>
            </CardBody>
        </Card>);
}
const export_receipt_data = (data) => {
    return data.map((item) => {
        return {
            order_id: item["order_id"],
            분류: item["type"],
            결재일: moment(item["order_date"]).format("YYYY-MM-DD HH:mm:ss"),
            사용일: moment(item["use_date"]).format("YYYY-MM-DD"),
            고객: item["username"] + "(" + item["phone_num"] + ")",
            // "phone_num": item["phone_num"],
            상품명: item["name"],
            상태: item["state"],
            상세정보: item["info"],
            key: item["payments_key"].slice(0, 5) + "..",
            금액: item["amount"],
        };
    });
};
const StatisticsAdjustment = () => {
    document.title = "CRM - Statistics - Adjustment";
    const [showDetail, setshowDetail] = useState(false);
    const [salesEntity, setSalesEntity] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [lastYearData, setLastYearData] = useState([]);
    const [showReceiptModal, setShowReceiptModal] = useState(false);
    const [receiptData, setReceiptData] = useState(null);
    const [receiptLoading, setReceiptLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
    const { data: billingStatus } = useQuery({
        queryKey: ["site-billing", "me", "status"],
        queryFn: () => siteBillingService.getMyStatus().then((response) => response.data),
    });
    const fetchData = async (start_date, end_date) => {
        const result = await getDataFromUrl(`${API_SALES_ADJUSTMENTS}?start_date=${start_date}&end_date=${end_date}`);
        // merge same month
        let _datas = [];
        for (let i = 0; i < result.length; i++) {
            const item = result[i];
            const month = moment(item["start_date"]).format("YYYY년 M월");
            const found = _datas.find((data) => data["year-month"] === month);
            if (found) {
                found.total_amount += item.total_amount;
                found.month_total_amount += item.total_amount;
                found.paid_cost += item.paid_cost;
                found.payout += item.payout;
                found.sales_detail.ticket = found.sales_detail.ticket.concat(item.sales_detail.ticket);
                found.sales_detail.pacakge = found.sales_detail.pacakge.concat(item.sales_detail.pacakge);
                found.sales_detail.voucher = found.sales_detail.voucher.concat(item.sales_detail.voucher);
            }
            else {
                if (moment().startOf("month").isBefore(moment(item.end_date))) {
                    continue;
                }
                _datas.push({
                    ...item,
                    "year-month": month,
                    start_date: moment(item.start_date).startOf("month").format("YYYY-MM-DD"),
                    end_date: moment(item.end_date).endOf("month").format("YYYY-MM-DD"),
                    month_total_amount: item.total_amount,
                    description: month,
                    // half: moment(item["start_date"]).format("DD") < 16 ? "1분기" : "2분기",
                });
            }
        }
        // append sum
        _datas.push({
            id: "sum_total",
            "year-month": "합계",
            month_total_amount: _datas.reduce((a, b) => a + b.total_amount, 0),
            total_amount: _datas.reduce((a, b) => a + b.total_amount, 0),
            paid_cost: _datas.reduce((a, b) => a + b.paid_cost, 0),
            payout: _datas.reduce((a, b) => a + b.payout, 0),
        });
        // setData(_datas);
        return _datas;
    };
    const refreshData = useCallback(() => {
        // get the end of this year
        const end_date = moment().endOf("year").format("YYYY-MM-DD");
        // get the start of this year
        const start_date = moment().startOf("year").format("YYYY-MM-DD");
        // const start_date = moment().startOf('year').subtract(3, 'months').format('YYYY-MM-DD');
        setLoading(true);
        fetchData(start_date, end_date)
            .then((data) => {
            setData(data);
        })
            .catch((err) => {
            console.log("fetch error", err);
        })
            .finally(() => {
            setLoading(false);
        });
        // get last year data
        const last_year_start_date = moment().startOf("year").subtract(1, "year").format("YYYY-MM-DD");
        const last_year_end_date = moment().endOf("year").subtract(1, "year").format("YYYY-MM-DD");
        fetchData(last_year_start_date, last_year_end_date)
            .then((data) => {
            setLastYearData(data);
        })
            .catch((err) => {
            console.log("LastYearData fetch error", err);
        })
            .finally(() => {
            // setLoading(false)
        });
    }, []);
    const fetchReceiptData = async () => {
        setReceiptLoading(true);
        const result = await getDataFromUrl(`${BACKEND_HOST}/sales-adjustments/receipt/`);
        setReceiptData(result);
        setReceiptLoading(false);
    };
    const refreshAdjustment = useCallback(async (targetDate) => {
        if (targetDate) {
            const result = await getDataFromUrl(`${BACKEND_HOST}/sites/site-statistic-adjustment/refresh/?yearmonth=${moment(targetDate).format("YYYY-MM")}`);
            console.log("refreshAdjustment", result);
            refreshData();
        }
    }, [refreshData]);
    const columns = useMemo(() => {
        const _columns = [
            {
                Header: "년월",
                accessor: "year-month",
                size: 150,
            },
            {
                Header: "월 정산매출",
                accessor: "year-month-total",
                size: 150,
                Cell: ({ row }) => <span>{formatPrice(row.original.month_total_amount)}</span>,
            },
            {
                Header: "상세내역",
                accessor: "detail",
                size: 260,
                className: "w-[260px] min-w-[260px]",
                Cell: ({ row }) => {
                    if (row.original.id === "sum_total")
                        return <></>;
                    // button show detail
                    return (<div className="flex flex-wrap items-center gap-2">
                            {/* {row.original.state === "created" && moment(row.original.end_date).isBefore(moment()) ? (
                  <Button
                    
                    onClick={() => {
                      setEndDate(row.original.end_date);
                      setStartDate(row.original.start_date);
                      setStatistic(row.original);
                      setshowUpdateModal(true);
                    }}
                   color="success" size="sm">
                    정산확인
                  </Button>
                ) : null} */}
                            <Button className="min-w-[88px]" onClick={() => {
                            setEndDate(row.original.end_date);
                            setStartDate(row.original.start_date);
                            setStatistic(row.original);
                            setshowDetail(true);
                            const offset = 90;
                            window.scrollTo({
                                behavior: 'smooth',
                                top: document.querySelector("#detail-table").getBoundingClientRect().top -
                                    document.body.getBoundingClientRect().top -
                                    offset,
                            });
                        }} color="success" size="sm">
                                상세보기
                            </Button>
                            <Button className="min-w-[120px]" onClick={async () => {
                            if (await dialogService.confirm("정산 내역이 변경되었을 경우, 다시 계산합니다. 실행하시겠습니까?"))
                                refreshAdjustment(row.original.start_date);
                        }} color="secondary" size="sm">
                                정산 새로고침
                            </Button>
                        </div>);
                },
            },
        ];
        return _columns;
    }, [refreshAdjustment]);
    const [recentAdjustment, setRecentAdjustment] = useState(null);
    const [isAdjustmentLoading, setIsAdjustmentLoading] = useState(false);
    const recentStartDate = moment().startOf("month").format("YYYY-MM-DD");
    const recentAdjustmentName = moment().startOf("month").format("M월");
    const recentEndDate = moment().format("YYYY-MM-DD");
    useEffect(() => {
        setIsAdjustmentLoading(true);
        getDataFromUrl(`${BACKEND_HOST}/sites/adjustment-receipt-list/?start_date=${recentStartDate}&end_date=${recentEndDate}`)
            .then((data) => {
            console.log("adjustment-receipt-list", data);
            const _data = data.result.filter((item) => {
                if (item.use_date === moment().format("YYYY-MM-DD")) {
                    return item.state !== "예약";
                }
                return true;
            });
            setRecentAdjustment(_data);
        })
            .finally(() => {
            setIsAdjustmentLoading(false);
        });
    }, [recentStartDate, recentEndDate]);
    useEffect(() => {
        refreshData();
    }, [refreshData]);
    useEffect(() => {
        // get sales entity
        getDataFromUrl(`${API_SALES_ADJUSTMENTS_ENTITY}?get_site=true`).then((result) => {
            console.log("API_SALES_ADJUSTMENTS_ENTITY", result);
            setSalesEntity(result[0]);
        });
    }, []);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [statistic, setStatistic] = useState(null);
    const ticket_total = statistic
        ? statistic["sales_detail"]["ticket"]
            .map((item) => {
            return item.ticket_total;
        })
            .reduce((sum, currValue) => {
            return sum + currValue;
        }, 0)
        : 0;
    const pacakge_total = statistic
        ? statistic["sales_detail"]["pacakge"]
            .map((item) => {
            return item.sum_total;
        })
            .reduce((sum, currValue) => {
            return sum + currValue;
        }, 0)
        : 0;
    const total_amount = ticket_total + pacakge_total;
    if (!salesEntity) {
        return (<React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="CRM" pageTitle="Statistics"/>
                        <Row>
                            <Col>
                                <Card className="h-auto">
                                    <CardHeader className="align-items-center d-flex">
                                        <h5 className="card-title mb-0">Adjustment</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <Spinner color="primary"> Loading... </Spinner>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>);
    }
    return (<React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="정산" pageTitle="통계"/>

	                    {loading && (<Row className="d-flex justify-content-center align-items-center">
	                            <Spinner color="primary"> Loading... </Spinner>
	                            <span className="ml-2">처리중입니다. 잠시 기다려 주세요...</span>
	                        </Row>)}

	                    <BillingOverviewCards billingStatus={billingStatus}/>

	                    <Row>
                        <Col>
	                            <Card className="h-auto">
	                                <CardHeader className="align-items-center d-flex">
	                                    <h5 className="card-title mb-0 flex-grow-1">정산 내역</h5>
	                                </CardHeader>
                                <CardBody>
                                    <div className="mb-4 w-full">
                                        <div className="w-full">
                                            {isAdjustmentLoading ? <Spinner color="primary"> Loading... </Spinner> : null}
                                            {recentAdjustment ? (<div className="grid w-full grid-cols-1 gap-3 lg:grid-cols-[minmax(280px,1fr)_minmax(220px,0.75fr)_minmax(220px,auto)]">
                                                    <Card className="h-full min-h-[96px] min-w-0 overflow-visible">
                                                        <CardBody>
                                                            <div className="d-flex align-items-center">
                                                                <div className="min-w-0 flex-grow-1 ms-3">
                                                                    <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">최근 기간:</p>
                                                                    <div className="flex min-w-0 flex-wrap items-end gap-x-1 gap-y-1">
                                                                        <h4 className="mb-0 leading-snug">{recentAdjustmentName}</h4>
                                                                        <span className="break-words text-sm leading-snug">({`${recentStartDate} ~ ${recentEndDate}`})</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                    <Card className="h-full min-h-[96px] min-w-0 overflow-visible">
                                                        <CardBody>
                                                            <div className="d-flex align-items-center">
                                                                <div className="avatar-sm flex-shrink-0">
                                                                    <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                                                                        <i className={"mdi align-middle " + "mdi-currency-krw"}></i>
                                                                    </span>
                                                                </div>
                                                                <div className="min-w-0 flex-grow-1 ms-3">
                                                                    <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">최근 정산 매출액</p>
                                                                    <h4 className="mb-0 break-words leading-snug">
                                                                        {/* <CountUp start={0}
            end={new Intl.NumberFormat().format(
                recentAdjustment.reduce((acc, cur) => {
                    return acc + cur.amount
                }, 0)
            )}
            decimals={"0"} separator={","} prefix={"￦"} duration={0.5} /> */}
                                                                        {new Intl.NumberFormat().format(recentAdjustment.reduce((acc, cur) => {
                return acc + cur.amount;
            }, 0))}
                                                                    </h4>
                                                                </div>
                                                                {/* <div className="flex-shrink-0 align-self-end">
                <span className={"badge badge-soft-" + item.badgeColor}><i className={"align-middle me-1 " + item.badge}></i>{item.percentage} %<span>
                </span></span>
            </div> */}
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                    <Card className="h-full min-h-[96px] min-w-0 overflow-visible">
                                                        <CardBody className="flex h-full items-center">
                                                            <Button onClick={() => {
                const result_data = export_receipt_data(recentAdjustment);
                openWindowWithTable(result_data);
            }} color="soft" className="w-full justify-center">
                                                                <i className="ri-printer-line"></i> 최근 내역보기
                                                            </Button>
                                                        </CardBody>
                                                    </Card>
                                                </div>) : null}
                                        </div>
                                    </div>

                                    <SummaryTable id={"summary-table"} columns={columns} data={data}/>

                                    <div style={{ height: "40px" }}></div>

                                    {lastYearData && lastYearData.length ? (<>
                                            <div>
                                                <p className="text-uppercase fw-semibold fs-16 text-muted mb-1">지난 년도 내역</p>
                                            </div>
                                            <SummaryTable id={"summary-last-year-table"} columns={columns} data={lastYearData}/>
                                        </>) : null}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <div id="detail-table"></div>

                    {showDetail && statistic ? (<>
                            <Row>
                                <Col>
	                                    <Card className="h-auto">
                                        <CardHeader className="align-items-center d-flex">
                                            <h5 className="card-title mb-0">기간 상세 내역</h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="">
                                                <div>
                                                    <span className="fs-6">
                                                        {statistic.description} {`${startDate} ~ ${endDate}`}
                                                    </span>
                                                </div>
	                                                <div>
	                                                    <span className="fs-6">총매출액: {new Intl.NumberFormat().format(statistic.total_amount)}원</span>
	                                                </div>
	                                                {/* {statistic.state === "created" && moment(statistic.end_date).isBefore(moment()) ? (
                <div>
                    <Button
                        
                        onClick={() => {
                            setEndDate(statistic.end_date);
                            setStartDate(statistic.start_date);
                            setStatistic(statistic);
                            // setshowUpdateModal(true);
                        }}
                     color="md">
                        정산확인
                    </Button>{" "}
                    <span className="px-1"> </span> 버튼을 눌러 정산을 확인해 주세요.
                </div>
            ) : (
                <div>
                    <span className="fs-6">지급예정급액: {new Intl.NumberFormat().format(statistic.payout)}</span>
                </div>
            )} */}

                                                <div className="mt-3"></div>
                                                <div className="flex flex-wrap items-center gap-2">
                                                    <Button onClick={() => {
                // adjustment-receipt-list
                getDataFromUrl(`${BACKEND_HOST}/sites/adjustment-receipt-list/?start_date=${startDate}&end_date=${endDate}`).then((data) => {
                    console.log("adjustment-receipt-list", `?start_date=${startDate}&end_date=${endDate}`, data);
                    const result_data = export_receipt_data(data["result"]);
                    openWindowWithTable(result_data);
                });
            }} color="light">
                                                        <i className="ri-printer-line"></i> 종합 내역보기
                                                    </Button>
                                                    <Button onClick={async () => {
                if (await dialogService.confirm("정산 내역을 엑셀파일로 저장하시겠습니까?")) {
                    getDataFromUrl(`${BACKEND_HOST}/sites/adjustment-receipt-list/?start_date=${startDate}&end_date=${endDate}`).then((data) => {
                        console.log("adjustment-receipt-list", `?start_date=${startDate}&end_date=${endDate}`, data);
                        const result_data = export_receipt_data(data["result"]);
                        const worksheet = utils.json_to_sheet(result_data);
                        const workbook = utils.book_new();
                        utils.book_append_sheet(workbook, worksheet, "id");
                        writeFileXLSX(workbook, "output.xlsx");
                    });
                }
            }} color="light">
                                                        <i className="ri-save-2-line"></i> 종합 엑셀파일
                                                    </Button>

                                                    <Button onClick={() => {
                setSelectedDate(startDate);
                fetchReceiptData();
                setShowReceiptModal(true);
            }} color="light">
                                                        <i className="ri-save-2-line"></i> 종합 엑셀파일(PG결제내역)
                                                    </Button>
                                                </div>

                                                <div className="mt-3"></div>
                                                <div>
                                                    <span className="fs-6">
                                                        티켓 주문 건수:{" "}
                                                        {statistic["sales_detail"]["ticket"]
                .map((item) => {
                return item.ticket_count;
            })
                .reduce((sum, currValue) => {
                return sum + currValue;
            }, 0)}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span className="fs-6">티켓 매출: {new Intl.NumberFormat().format(ticket_total)}</span>
                                                </div>
                                                <div className="flex flex-wrap items-center gap-2">
                                                    <Button onClick={() => {
                getDataFromUrl(`${API_TICKET_ALL}/?start_date=${startDate}&end_date=${endDate}`).then((data) => {
                    console.log("API_TICKET_ALL", `?start_date=${startDate}&end_date=${endDate}`, data);
                    const result_data = export_ticket_data(data);
                    openWindowWithTable(result_data);
                });
            }} color="light">
                                                        <i className="ri-printer-line"></i> 티켓매출 내역보기
                                                    </Button>
                                                    <Button onClick={() => {
                getDataFromUrl(`${API_TICKET_ALL}/?start_date=${startDate}&end_date=${endDate}`).then((data) => {
                    console.log("API_TICKET_ALL", `?start_date=${startDate}&end_date=${endDate}`, data);
                    const result_data = export_ticket_data(data);
                    const worksheet = utils.json_to_sheet(result_data);
                    const workbook = utils.book_new();
                    utils.book_append_sheet(workbook, worksheet, "id");
                    writeFileXLSX(workbook, "output.xlsx");
                });
            }} color="light">
                                                        <i className="ri-save-2-line"></i> 티켓매출 엑셀파일
                                                    </Button>
                                                </div>
                                                <div className="mt-3"></div>
                                                <div>
                                                    <span className="fs-6">
                                                        예약 주문 건수:{" "}
                                                        {statistic["sales_detail"]["pacakge"]
                .map((item) => {
                return item.reserv_count;
            })
                .reduce((sum, currValue) => {
                return sum + currValue;
            }, 0)}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span className="fs-6">예약 매출: {new Intl.NumberFormat().format(pacakge_total)}</span>
                                                </div>
                                                <div className="flex flex-wrap items-center gap-2">
                                                    <Button onClick={() => {
                getDataFromUrl(`${API_RESERVATION_ALL}/?start_date=${startDate}&end_date=${endDate}`).then((data) => {
                    console.log("API_RESERVATION_ALL", `?start_date=${startDate}&end_date=${endDate}`, data);
                    const result_data = export_reservation_data(data);
                    openWindowWithTable(result_data);
                });
            }} color="light">
                                                        <i className="ri-printer-line"></i> 예약매출 내역보기
                                                    </Button>
                                                    <Button onClick={() => {
                getDataFromUrl(`${API_RESERVATION_ALL}/?start_date=${startDate}&end_date=${endDate}`).then((data) => {
                    console.log("API_RESERVATION_ALL", `?start_date=${startDate}&end_date=${endDate}`, data);
                    const result_data = export_reservation_data(data);
                    const worksheet = utils.json_to_sheet(result_data);
                    const workbook = utils.book_new();
                    utils.book_append_sheet(workbook, worksheet, "id");
                    writeFileXLSX(workbook, "output.xlsx");
                });
            }} color="light">
                                                        <i className="ri-save-2-line"></i> 예약매출 엑셀파일
                                                    </Button>
                                                </div>

                                                <div className="mt-3"></div>
                                                <div>
                                                    <span className="fs-6">
                                                        교환권 사용건수:{" "}
                                                        {statistic["sales_detail"]["voucher"]
                .map((item) => {
                return item.count;
            })
                .reduce((sum, currValue) => {
                return sum + currValue;
            }, 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <StatisticDetail title={"티켓판매 상세"} headers={[
                { name: "상품명", id: "name" },
                { name: "사용완료 건수", id: "ticket_count" },
                { name: "티켓 매출", id: "ticket_total" },
            ]} datas={statistic["sales_detail"]["ticket"]}/>
                            </Row>

                            <Row>
                                <StatisticDetail title={"예약상품판매 상세"} headers={[
                { name: "상품명", id: "name" },
                { name: "사용완료 건수", id: "reserv_count" },
                { name: "예약 매출", id: "reserv_total" },
                { name: "옵션 건수", id: "optinos_count" },
                { name: "옵션 매출", id: "options_total" },
                { name: "총 매출", id: "sum_total" },
            ]} datas={statistic["sales_detail"]["pacakge"]}/>
                            </Row>

                            <Row>
                                <StatisticDetail title={"교환권 상세"} headers={[
                { name: "상품명", id: "name" },
                { name: "건수", id: "count" },
            ]} datas={statistic["sales_detail"]["voucher"]}/>
                            </Row>
                        </>) : null}
                </Container>


                <ReceiptModal show={showReceiptModal} onCloseClick={() => {
            setShowReceiptModal(false);
        }} loading={receiptLoading} receiptData={receiptData ? receiptData.filter((item) => {
            const yearmonth = moment(item["start_date"]).format("YYYY-MM");
            const selectedYearMonth = moment(selectedDate).format("YYYY-MM");
            return yearmonth === selectedYearMonth;
        }) : []} refetch={fetchReceiptData} onStartJob={() => {
            postData(`${BACKEND_HOST}/sales-adjustments/receipt/`, {
                start_date: moment(selectedDate).startOf("month").format("YYYY-MM-DD"),
                end_date: moment(selectedDate).endOf("month").format("YYYY-MM-DD"),
            })
                .then((result) => {
                console.log("receipt start job", result);
                fetchReceiptData();
            })
                .catch((err) => {
                console.log("receipt start job error", err);
            });
        }}/>
            </div>
        </React.Fragment>);
};
export default StatisticsAdjustment;
